import React from 'react';
import Body from './Components/Body';
import Button from 'screens/components/basic/Button';
import Grid from 'screens/components/basic/Grid';
import { productViewCrumb } from 'utils/breadcrumbInfo';

const ProductView = (props) => {
    return (
        <Grid headerContent={productViewCrumb}>
            <Body {...props} />
        </Grid>
    );
};

export default ProductView;